import React, { useEffect, useRef, useState } from "react";

import { IProps } from "./interfaces";
import { StyledTimer } from "./styles";

const getTime = (startedAt: number) => {
    const timeLeft = (new Date().getTime() - startedAt) / 1000;
    let seconds = "0" + Math.floor(timeLeft - Math.floor(timeLeft / 60) * 60).toString();
    seconds = seconds.slice(-2);
    let minutes = Math.floor(timeLeft / 60);
    return `${minutes}:${seconds}`;
};

const Timer = ({ startedAt }: IProps) => {
    const timer = useRef<ReturnType<typeof setInterval>>();
    const [time, setTime] = useState(getTime(startedAt));
    useEffect(() => {
        timer.current = setInterval(() => {
            setTime(getTime(startedAt));
        }, 1000);
        return () => {
            clearInterval(timer.current);
        }
    }, []);
    
    return (
        <StyledTimer>
            {time}
        </StyledTimer>
    );
}

export default Timer;
